import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ReactComponent as ExclamationIcon } from '../../images/exclamation-icon.svg';
import styles from './GeneralError.module.css';

type ErrorBoundaryState = {
  hasError: boolean;
  error: string;
};

type ErrorBoundaryProps = { children?: React.ReactNode | React.ReactNode[] };

export default class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: Readonly<ErrorBoundaryProps>) {
    super(props);
    this.state = { hasError: false, error: '' };
  }

  static getDerivedStateFromError(error: { toString: () => string }) {
    return { hasError: true, error: error.toString() };
  }

  componentDidCatch(error: unknown, info: unknown) {
    console.error(error, info);
  }

  refreshPage() {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={styles.background}>
          <div className={styles.container}>
            <div className={styles.content}>
              <div className={styles.errorIconBackground}>
                <ExclamationIcon className={styles.exclamationIcon} />
              </div>
              <div className={styles.titleText}>
                <FormattedMessage id={'generalError.title'} />
              </div>
              <div className={styles.titleSubText}>
                <FormattedMessage id={'generalError.body'} />
              </div>
              <div className={styles.errorContainer}>{this.state.error}</div>
            </div>
            <div className={styles.refreshButton} onClick={this.refreshPage}>
              <FormattedMessage id={'generalError.button'} />
            </div>
          </div>
        </div>
      );
    }

    // If there is no error just render the children component.
    return this.props.children;
  }
}
